export function logger(type: string, ...args: unknown[]) {
  const showLogger = window.location.search.includes(`debug=${type}`);
  const showLoggerStack = window.location.search.includes('stack=1');
  if (showLogger) {
    if (showLoggerStack) {
      try {
        throw new Error('');
      } catch (err) {
        console.log(`%c${type}`, 'background:green;color:white', ...args, err);
      }
    } else {
      console.log(`%c${type}`, 'color:white!important;background:blue;', ...args);
    }
  }
}
